// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import CarType from 'Common/CarType';

// Helpers
import classNames from 'classnames';
import { createValue } from 'Common/formValues';
import { topEightCarTypes } from 'Common/filterValues';
import chunk from 'Common/chunk';

/**
 * <CarTypes /> component.
 */
class CarTypes extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    fields: PropTypes.object,
    additonalOptions: PropTypes.object,
    isLoading: PropTypes.bool
  };

  /**
   * Renders <CarTypes /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render() {
    const { styles, fields, isLoading } = this.props;
    const { category } = this.props.additonalOptions;

    const orderedCategories = topEightCarTypes.map(_ =>
      category.filter(item => item.key === _.key)[0]
        ? category.filter(item => item.key === _.key)[0]
        : _
    );
    const chunkedCategories = chunk(orderedCategories, 2);

    return (
      <div className={classNames(styles.formRow, styles.formRowCarTypes)}>
        {chunkedCategories &&
          chunkedCategories.map((item, index) => (
            <div className={classNames(styles.formRowItem)} key={index}>
              <div className={classNames(styles.doubleSelect)}>
                {item.map((_, i) => (
                  <CarType
                    key={i}
                    name={'category'}
                    size={'large'}
                    label={_.key}
                    results={
                      (_.doc_count && _.doc_count.toLocaleString('en')) || 0
                    }
                    selectedValue={fields.category}
                    value={createValue(_)}
                    isDisabled={isLoading}
                  />
                ))}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

export default CarTypes;



// WEBPACK FOOTER //
// ./src/Home/CarTypes/index.js